"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._RadioField = exports.RadioField = exports.InlineRadioField = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../../../common/utils");
var _Alert = _interopRequireDefault(require("../../../../../componentLibrary/layout/Alert"));
var _lodash = _interopRequireDefault(require("lodash"));
var _immer = require("immer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _RadioField = /*#__PURE__*/function (_React$Component) {
  _inherits(_RadioField, _React$Component);
  var _super = _createSuper(_RadioField);
  function _RadioField() {
    var _this;
    _classCallCheck(this, _RadioField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.render = function () {
      var _this$props = _this.props,
        name = _this$props.name,
        handleChange = _this$props.handleChange,
        value = _this$props.value,
        options = _this$props.options,
        formOptions = _this$props.formOptions,
        handleBlur = _this$props.handleBlur,
        label = _this$props.label,
        displayError = _this$props.displayError,
        detachedLabel = _this$props.detachedLabel,
        errorId = _this$props.errorId;
      var overheadLabel = label || detachedLabel;
      var parsedValue = _lodash.default.clone(value);
      if (_lodash.default.toLower(parsedValue) === 'true') parsedValue = true;
      if (_lodash.default.toLower(parsedValue) === 'false') parsedValue = false;
      var parsedOptions = _lodash.default.clone(options);
      parsedOptions = (0, _immer.produce)(options, function (draft) {
        _lodash.default.each(draft, function (draftItem) {
          if (_lodash.default.toLower(draftItem.value) === 'true') draftItem.value = true;
          if (_lodash.default.toLower(draftItem.value) === 'false') draftItem.value = false;
        });
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Group, {
        grouped: true
      }, options.map(function (option) {
        var alertArray = [];
        _lodash.default.map(option.disableOn, function (disabledOn) {
          if (disabledOn && disabledOn.disabled && disabledOn.alertHeading) {
            var alertElement = /*#__PURE__*/_react.default.createElement(_Alert.default, {
              size: "mini",
              header: disabledOn.alertHeading,
              content: disabledOn.alertText,
              type: "warning",
              dismissable: false
            });
            alertArray.push(alertElement);
          }
        });
        return alertArray;
      }), _lodash.default.map(parsedOptions, function (option) {
        var disabled = false;
        _lodash.default.map(option.disableOn, function (disabledOn) {
          disabled = disabled || disabledOn.disabled;
        });
        var label = option.label;
        var checked = parsedValue === option.value;
        if (checked === false && (option.value === 'Y' || option.value === true)) {
          if (parsedValue === true) {
            checked = true;
          }
        } else if (checked === false && (option.value === 'N' || option.value === false)) {
          if (parsedValue === false) {
            checked = true;
          }
        }
        if (!_lodash.default.isEmpty(option.links)) {
          label = (0, _utils.buildBookmarkLink)(_objectSpread(_objectSpread({}, option), {}, {
            content: option.label,
            setCurrentFieldList: _this.props.setCurrentFieldList
          }));
        }
        disabled = formOptions && formOptions.disabled ? formOptions.disabled : disabled;
        return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, {
          key: "".concat(name, "-").concat(option.value),
          name: name,
          id: name + '-' + option.value,
          control: _semanticUiReact.Radio,
          title: overheadLabel,
          onChange: handleChange,
          label: label,
          "aria-describedby": displayError ? errorId : null,
          value: option.value,
          checked: checked,
          disabled: disabled,
          onBlur: handleBlur,
          readOnly: formOptions && formOptions.readOnly ? formOptions.readOnly : false,
          "aria-label": "".concat(option.value)
        });
      })));
    };
    return _this;
  }
  return _createClass(_RadioField);
}(_react.default.Component);
exports._RadioField = _RadioField;
_RadioField.propTypes = {
  /** For the question */
  value: _propTypes.default.any,
  options: _propTypes.default.array,
  /** Functions */
  handleChange: _propTypes.default.func.isRequired,
  handleBlur: _propTypes.default.func
};
_RadioField.defaultProps = {
  options: [{
    label: 'Yes',
    value: 'Y'
  }, {
    label: 'No',
    value: 'N'
  }, {
    label: 'Not applicable',
    value: 'N/A'
  }]
};
var RadioField = (0, _utils.enhance)(_RadioField);
exports.RadioField = RadioField;
var InlineRadioField = (0, _utils.enhanceInline)(_RadioField);
exports.InlineRadioField = InlineRadioField;